import {
    BreadcrumbsDispatcher as SourceBreadcrumbsDispatcher
} from 'SourceStore/Breadcrumbs/Breadcrumbs.dispatcher';
import { toggleBreadcrumbs, updateBreadcrumbs } from 'Store/Breadcrumbs/Breadcrumbs.action';

export class BreadcrumbsDispatcher extends SourceBreadcrumbsDispatcher {
    updateWithProduct(product, cats, dispatch) {
        if (cats.length && cats[cats.length - 1].name !== __('Home')) {
            const breadcrumbs = this._getProductBreadcrumbs(product, cats);
            dispatch(toggleBreadcrumbs(true));
            dispatch(updateBreadcrumbs(breadcrumbs));
        } else {
            dispatch(toggleBreadcrumbs(false));
        }
    }

    updateWithCmsPage({ title }, dispatch) {
        const breadcrumbs = title
            ? [
                {
                    url: '',
                    name: title
                }
            ]
            : [];

        dispatch(updateBreadcrumbs(breadcrumbs));
    }

    _getProductBreadcrumbs(product, cats) {
        const { url, name } = product;

        const breadcrumbsName = name.split(' - ')[0];

        return [
            { url, name: breadcrumbsName },
            ...cats.filter(item => item.name.indexOf(breadcrumbsName) === -1)
        ];
    }
}

export default new BreadcrumbsDispatcher();
